/**
 * Created by zuozhuo on 2018/1/25.
 */
import React from "react";
import utils from "../utils/utils";
import querystring from "querystring";
import DebugFloatIcon from "../components/DebugFloatIcon";
// import ShortcutNavigation from "../components/ShortcutNavigation";
import config from "../consts/config";
import foStorage from "../utils/foStorage";

class RootView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobxDevtools: null
    };
  }

  async componentDidMount() {
    console.log("RootView init");
    if (utils.isDebug()) {
      /*await this.initMobxDevTools();
      if (!await this.initWeinreDebug()) {
        await this.initVConsole();
      }*/
    }

    if (window.location.href.indexOf("#debug") > -1) {
      // 同步改动到storage, 只保存一个小时
      const expires = new Date().getTime() + 3600 * 1000;
      foStorage.setItem(
        foStorage.KEYS.debugSettings,
        {
          jssdkDebug: false,
          vconsole: true,
          weinre: false
        },
        expires
      );
    }
  }

  getHashQuery() {
    return querystring.parse(window.location.hash.slice(1));
  }

  async initWeinreDebug() {
    const hashQuery = this.getHashQuery();
    if (hashQuery.weinre_host) {
      utils.appendScript(
        `http://${hashQuery.weinre_host}/target/target-script-min.js#anonymous`
      );
      return true;
    }
    return false;
  }

  async initVConsole() {
    const VConsole = await import("vconsole");
    new VConsole();
    return true;
  }

  async initMobxDevTools() {
    const Devtools = await import("mobx-react-devtools");
    this.setState({
      mobxDevtools: <Devtools.default position={{ bottom: -1, left: -3 }} />
    });
    return true;
  }

  renderDebugIcon() {
    if (!utils.isDebugMode()) {
      return null;
    }
    return <DebugFloatIcon />;
  }

  render() {
    return (
      <div className="fo-app-root-view">
        {this.props.children}
        {this.state.mobxDevtools}
        {this.renderDebugIcon()}
        {/* <ShortcutNavigation /> */}
      </div>
    );
  }
}

export default RootView;



// WEBPACK FOOTER //
// ./src/pages/RootView.js